import "es6-promise";
import { reduce } from './directory-reducer';
import * as Actions from './actions';

import { RouterToUrlQuery } from 'react-url-query';
import { BrowserRouter } from 'react-router-dom';
import * as Rx from 'rx';
import * as redux from 'redux';
import { Store, createStore, applyMiddleware } from 'redux';

import { render } from 'react-dom';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

import * as React from 'react';
import * as _ from 'lodash';
import DirectoryContainer from './directory-container';
import { IDirectoryState, IMember, defaultDirectoryModel } from './classes';
import ReactDOM = require("react-dom");

/**
 * Exposes the dispatch of the redux store for manual dispatches.
 */
export function directoryDispatch(): redux.Dispatch<IDirectoryState<IMember>> {
    return _directoryState.dispatch;
}

/**
 * Exposes the current state of the directory redux store.
 */
export function directoryStore(): redux.Store<IDirectoryState<IMember>> {
    return _directoryState;
}

createDirectoryStore(defaultDirectoryModel);

var appStore = directoryStore();

directoryDispatch()(Actions.initializeMembers((window as any).bootStrappedData));

const appMount = document.getElementById('app-container');
ReactDOM.render(
    <Provider store={appStore}>
        <BrowserRouter>
            <RouterToUrlQuery>
                <DirectoryContainer />
            </RouterToUrlQuery>
        </BrowserRouter>
    </Provider>, appMount
);


var _directoryState: redux.Store<any>;
var _defaultDirectoryModel: IDirectoryState<IMember>;


export function createDirectoryStore(directoryModel: IDirectoryState<IMember> = defaultDirectoryModel) {
    _defaultDirectoryModel = directoryModel;

    // Default initial state to the default directory model
    let initialState = defaultDirectoryModel;

    // Check the hash for an initial state
    if (window.location.hash) {
        const state = window.location.hash;

        if (Object.keys(state).some(_.identity)) {
            //initialState = deserializeProps(state);
        }
    }

    _directoryState = redux.createStore(reduce, initialState);
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/affiliate-directory/affiliate-directory.tsx